import React, { useEffect } from 'react'
import noData from "./../../../assets/img/NoDataFound.svg"
const NoDataFound = ({ isLoading, rows , ...props }) => {
    let condition = props?.type === "lengthInRows" ?  rows === 0 : rows?.length === 0;

    return (
        <div>
            {isLoading ? null :
                condition ?
                    <div className='no_data'>
                        <div>
                            <img src={noData} />
                            <p>No Data Found</p>
                        </div>
                    </div> : null
             }
            </div>
    )
}

export default NoDataFound